















  import Vue from 'vue';
  import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
  import DocumentViewer from '@/components/shared/DocumentViewer.vue';
  import ErrorNotification from '@/components/shared/ErrorNotification.vue';
  import { mapGetters } from 'vuex';
  import { 
    ErrorModel, 
    DocumentViewerConstants,
    DataLookupState,
    StickyStoreNames, 
    StickySettingsGetters, 
    StickySettingsFields
  } from '@/types';
  export default Vue.extend({
    name: 'Dashboard',
    data(this: any) {
      return {
        errorModel: {
          showHeader: false,
          message: `There are no documents currently waiting to be stored.
Please refresh the page or upload more documents to store.`,
          showButton: false
        } as ErrorModel,
        documentViewerToolbarOptions: DocumentViewerConstants.PageDisabledOutsideStoreToolOptions
      };
    },
    computed: {
      ...mapGetters(StickyStoreNames.DocumentsToStore, [StickySettingsGetters.GetStickyStateField]),
      documentLookupState(this: any): DataLookupState {
        return this.getStickyStateField(StickySettingsFields.DocumentsLookupState);
      },
      showNoDocumentNotification(this: any) {
        return this.documentLookupState === DataLookupState.NoData;
      },
      showLoadingSpinner(this: any) {
        return this.documentLookupState === DataLookupState.Loading;
      }
    },
    components: {
      LoadingSpinner,
      DocumentViewer,
      ErrorNotification
    }
  });
